import { JhText } from "designPackages/textPackage";
import React from "react";

interface DiscountedCreditsViewProps {
  mrc: number;
  discountedCredits: number;
}

const DiscountedCreditsView = ({
  mrc,
  discountedCredits
}: DiscountedCreditsViewProps): JSX.Element => {
  return (
    <div className="flex items-center">
      {discountedCredits !== mrc ? (
        <JhText
          color="muted-foreground"
          variant="body2"
          className="line-through"
        >
          {mrc}
        </JhText>
      ) : null}
      <img
        className="ml-1 mr-0.5"
        height={"16px"}
        width={"16px"}
        src="/hire/coin-icon.svg"
        alt="coin"
      />
      <JhText color="foreground" className="mr-1" variant="emphasis4">
        {discountedCredits}
      </JhText>
    </div>
  );
};

export default DiscountedCreditsView;
